<template lang="pug">
  div
    app-header
    div Integration
</template>

<script>
  import AppHeader from '@/components/AppHeader'

  export default {
    name: 'Integration',
    components: {
      AppHeader
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Integration.vue